import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dPackage2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-Icon3dPackage2"><Path d="M11.252 12.4326V22.6826L2.375 17.5576V7.30762L11.252 12.4326Z" fill="currentColor"/><Path d="M21.6289 17.5576L12.752 22.6826V12.4326L16.6904 10.1582V14.8701L18.1904 14.0039V9.29199L21.6289 7.30762V17.5576Z" fill="currentColor"/><Path d="M15.6895 9.00391L12.002 11.1338L3.125 6.00879L6.81348 3.87891L15.6895 9.00391Z" fill="currentColor"/><Path d="M20.8779 6.00879L17.1895 8.1377L8.3125 3.0127L12.002 0.883789L20.8779 6.00879Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon3dPackage2;
